export default theme => ({
  root: {
    width: '100%',
    boxSizing: 'border-box',
    padding: 16,
    borderRadius: 8,
    backgroundColor: theme.colors.background.white
  },
  withMarginTop: {
    marginTop: 16
  },
  toggleContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  baseLeft: {
    display: 'flex',
    gap: 8
  },
  baseRight: {
    display: 'flex',
    gap: 8
  },
  advancedContainer: {
    marginTop: 10
  },
  options: {
    width: '100%',
    marginTop: 8,
    display: 'flex'
  },
  option: {
    display: 'flex',
    gap: 10,
    alignItems: 'center'
  },
  popover: {
    maxWidth: 'none'
  },
  popoverContainer: {
    padding: 8,
    display: 'flex',
    alignItems: 'center'
  },
  popoverImage: {
    width: 450,
    height: 280
  },
  popoverTextContainer: {
    maxWidth: 300,
    padding: '0 8px',
    display: 'flex',
    alignItems: 'center'
  },
  popoverText: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    gap: 16
  },
  popoverTextMarkdown: {}
});